module.exports = __webpack_public_path__ + "img/file-table.f862e4bc.svg";